"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FoodInStock = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.9809676,10 L16.5990685,10 C15.2609297,8.75882545 13.4690815,8 11.5,8 C7.35786438,8 4,11.3578644 4,15.5 L4,18 L14,18 L14,19 L2,19 L2,18 L3,18 L3,15.5 C3,10.973427 6.53831026,7.27327069 11,7.01446179 L11,6 L9,6 L9,5 L14,5 L14,6 L12,6 L12,7.01446179 C14.3942525,7.15334501 16.5226031,8.28321917 17.9809676,10 L17.9809676,10 Z M22.8711668,14.146791 C23.0660394,14.3416637 23.0660394,14.6576147 22.8711668,14.8524873 L22.8704615,14.8531911 L18.4987257,19.2075037 L16.1462889,16.8514825 C15.951132,16.6560283 15.9512525,16.3394124 16.1465581,16.1441067 C16.3416192,15.9490457 16.6578757,15.9490457 16.8529368,16.1441067 L16.8533005,16.1444708 L18.4987257,17.7932901 L22.1632305,14.1459596 C22.3590853,13.9510227 22.6757704,13.9513947 22.8711668,14.146791 Z" })));
};
FoodInStock.displayName = 'FoodInStock';
exports.default = FoodInStock;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FoodInStock.js.map